import React from 'react';

const TileSkeleton = () => {
  return (
    <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 shadow-lg animate-pulse">
      {/* Header skeleton */}
      <div className="flex items-center justify-between mb-4">
        <div className="h-6 bg-white/20 rounded w-32"></div>
        <div className="h-8 w-8 bg-white/20 rounded-full"></div>
      </div>
      
      {/* Content skeleton */}
      <div className="space-y-3 mb-4">
        <div className="h-4 bg-white/20 rounded w-full"></div>
        <div className="h-4 bg-white/20 rounded w-3/4"></div>
        <div className="h-4 bg-white/20 rounded w-1/2"></div>
      </div>
      
      {/* Tags skeleton */}
      <div className="flex gap-2 mb-4">
        <div className="h-6 bg-white/20 rounded-full w-16"></div>
        <div className="h-6 bg-white/20 rounded-full w-20"></div>
        <div className="h-6 bg-white/20 rounded-full w-12"></div>
      </div>
      
      {/* Footer skeleton */}
      <div className="flex items-center justify-between">
        <div className="h-4 bg-white/20 rounded w-24"></div>
        <div className="h-4 bg-white/20 rounded w-16"></div>
      </div>
    </div>
  );
};

const TileSkeletonGrid = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 p-6">
      {Array.from({ length: 8 }).map((_, index) => (
        <TileSkeleton key={index} />
      ))}
    </div>
  );
};

export default TileSkeletonGrid;